// import { FACEBOOK_APP_ID } from '../config/credentials';

export default {

  'vimeo-api' : {
    url : 'https://player.vimeo.com/api/player.js',
    test () {
      if ( !window.Vimeo ) return false;
      console.info('Vimeo player API loaded!');
      return true;
    }
  },

  // 'jquery-panzoom' : {
  //   // url : 'https://cdnjs.cloudflare.com/ajax/libs/jquery.panzoom/3.2.2/jquery.panzoom.min.js',
  //   url : '/wp-content/themes/globalmana/assets/scripts/utilities/jquery.panzoom.js',
  //   test () {
  //     if ( !$.fn.panzoom ) return false;
  //     console.info('jquery-panzoom loaded!');
  //     return true;
  //   }
  // },

  // 'jquery-validate' : {
  //   url : 'https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.16.0/jquery.validate.min.js',
  //   test () {
  //     if ( !$.fn.validate ) return false;
  //     console.info('jquery-validate loaded!');
  //     return true;
  //   }
  // },


  // 'facebook' : {
  //   url : '//connect.facebook.net/en_US/sdk.js',
  //   test () {
  //     if ( !window.FB ) return false;
  //     console.info('facebook loaded!');
  //     return true;
  //   },
  //   init : function (callback) {
  //     FB.init({
  //       appId: FACEBOOK_APP_ID,
  //       version: 'v2.7' // or v2.1, v2.2, v2.3, ...
  //     });
  //     callback();
  //   }
  // },


  // 'dotdotdot' : {
  //   url : 'https://cdnjs.cloudflare.com/ajax/libs/jQuery.dotdotdot/1.7.4/jquery.dotdotdot.min.js',
  //   test () {
  //     if ( !$.fn.dotdotdot ) return false;
  //     console.info('jquery-dotdotdot loaded!');
  //     return true;
  //   }
  // },

  // 'dotdotdot-forked' : {
  //   url : '/wp-content/themes/globalmana/assets/scripts/utilities/dotdotdot.js',
  //   test () {
  //     if ( !$.fn.dotdotdot ) return false;
  //     console.info('jquery-dotdotdot-forked loaded!');
  //     return true;
  //   },
  // },


  // 'ellipsis' : {
  //   url : '/wp-content/themes/globalmana/assets/scripts/utilities/jquery.ellipsis.min.js',
  //   test () {
  //     if ( !$.fn.ellipsis ) return false;
  //     console.info('jquery-ellipsis loaded!');
  //     return true;
  //   }
  // },


  // 'facebook' : {
  //   url : '//connect.facebook.net/en_US/sdk.js',
  //   test : function () {
  //     if ( !window.FB ) return false;
  //     console.info('facebook loaded!');
  //     return true;
  //   },
  //   init : function (callback) {
  //     FB.init({
  //       appId: FACEBOOK_APP_ID,
  //       version: 'v2.7' // or v2.1, v2.2, v2.3, ...
  //     });
  //     callback();
  //   }
  // }

}
